export default [
  {
    path: "/board",
    component: () => import("@/views/board/index.vue"),
    meta: { title: "공지·문의" },
    children: [
      {
        path: "notice",
        children: [
          {
            path: "",
            name: "NoticeList",
            component: () => import("@/views/board/notice/List.vue"),
            meta: { title: "공지·문의 공지사항" },
          },
          {
            path: "detail/:id",
            name: "NoticeDetail",
            component: () => import("@/views/board/notice/Detail.vue"),
            meta: { title: "공지·문의 공지사항 상세" },
          },
        ],
      },
      {
        path: "tech-support",
        name: "TechSupport",
        component: () => import("@/views/board/tech-support/index.vue"),
        meta: { title: "공지·문의 기술지원" },
      },
      {
        path: "inquiry",
        children: [
          {
            path: "",
            name: "InquiryList",
            component: () => import("@/views/board/inquiry/List.vue"),
            meta: { title: "공지·문의 1:1 문의" },
          },
          {
            path: "detail/:id",
            name: "InquiryDetail",
            component: () => import("@/views/board/inquiry/Detail.vue"),
            meta: { title: "공지·문의 1:1 문의 상세" },
          },
          {
            path: "write",
            name: "InquiryWrite",
            component: () => import("@/views/board/inquiry/Write.vue"),
            meta: { title: "공지·문의 1:1 문의 작성" },
          },
        ],
      },
    ],
  },
];
